import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums';

@Injectable()
export class GruppoService extends BaseService {

  /**
   * Costruttore
   * @param http Servizio di richieste HTTP 
   */
  constructor(http: Http) {
    super(http);
  }

  /**
   * Get list of Gruppi
   * @param reqBuilder 
   */
  getAllGruppi(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('gruppo/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Save/update Gruppo
   * @param reqBuilder 
   */
  save(reqBuilder: RequestBuilder): Observable<any> {
    return this.doPost('gruppo/save', reqBuilder, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * delete Gruppo
   * @param reqBuilder 
   */
  deleteGruppo(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('gruppo/delete', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * Get list of Gruppi by role
   * @param reqBuilder 
   */
  getGruppiByRuolo(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('gruppo/fetchByRole', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }

  /**
   * associa ad un gruppo una o più commesse
   * aggiunto in data 07/09/2020
   * @param reqBuilder 
   */
  associaCommesseAlGruppo(reqBuilder?: RequestBuilder) {
    let payload
    if (reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('gruppo/associacommesse', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }
}
